export function downloadDataUrl(dataUrl, filename) {
  if (!dataUrl) return;
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function slugFilename(name, suffix) {
  const base = (name || "brand").trim().replace(/[^a-z0-9]+/gi, "-").replace(/^-+|-+$/g, "") || "brand";
  return `${base}-${suffix}.png`;
}
